/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Selected/Content"
  
}) {
let cardSelectedValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'selected',
})
let cardTypeValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'type',
})
let constantData = 'NO_MATCH'
let aggregateData = fromAggregate.equals(cardTypeValueData, constantData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="card.selected"
 value={cardSelectedValueData}
 onChange={onChange}
 marginRight={6}
 data="card.type"
 data="'NO_MATCH'"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 height={18}
 width={18}
/>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}